import React from 'react';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_left, l_chevron_right } from '@fiverr-private/fit/icons';
import { getContext } from '@fiverr-private/fiverr_context';
import { PaginationPropTypes } from '../../../types';
import { MAX_INDEX } from '../../../utils/constants';
import FirstPageButton from './first_page_button';
import { renderPageNumbers, pageUrl } from './utils';
import './style.scss';

const Pagination = ({ pagination }) => {

    /**
     * Calculate what pages pagination to show
     * @param { number } page - the current page we are on
     */

    const { isTouch } = getContext();

    const { page, page_size, total, offset }  = pagination;

    const totalPages = Math.ceil(total / page_size);
    const numberOfPages = Math.min(MAX_INDEX, totalPages);

    const hideLeftArrow = page === 1,
        hideRightArrow = page === numberOfPages || total === 0;

    const ulClassNames = classNames('page-pagination', { 'desktop': !isTouch });
    const arrowsClassNames = classNames('pagination-arrows', { 'is-touch': isTouch });
    const leftArrowClasses = classNames(arrowsClassNames, { 'hide-arrow': hideLeftArrow });
    const rightArrowClasses = classNames(arrowsClassNames, { 'hide-arrow': hideRightArrow });

    const nextUrl = pageUrl(page + 1, offset);
    const prevUrl = pageUrl(page - 1, offset);
    const firstPageUrl = pageUrl(1, offset);

    return (
        <ul id="pagination" className={ulClassNames}>
            <FirstPageButton page={page} firstPageUrl={firstPageUrl} arrowsClassNames={arrowsClassNames}/>
            <li className={leftArrowClasses}>{!hideLeftArrow && <a href={prevUrl}><Icon className="pagination-icon">{l_chevron_left}</Icon></a>}</li>
            {renderPageNumbers(page, numberOfPages, offset, isTouch)}
            <li className={rightArrowClasses}>{!hideRightArrow && <a href={nextUrl}><Icon className="pagination-icon">{l_chevron_right}</Icon></a>}</li>
        </ul>
    );
};

Pagination.propTypes = PaginationPropTypes;

export default Pagination;
